/* eslint-disable no-use-before-define */

import { spRatings, moodysRatings } from '../../twd/fields/ratings'
import { parseDate } from '../../twd'

export default (values) => {
    checkRatingIndicator(values)

    return {
    ...validateMaturity(values, 'holdMaturity'),
    ...validateNumbers(values, 'quantity'),
    ...validateNumbers(values, 'offerYtw'),
    ...validateNumbers(values, 'clientPrice'),
    ...validateRatings(values, 'holdSpRating', spRatings),
    ...validateRatings(values, 'holdMoodyRating', moodysRatings),
    }
}

const checkRatingIndicator = (values) => {
    const { holdSpRatingMin:sMin, holdSpRatingMax:sMax, holdMoodyRatingMin:mMin, holdMoodyRatingMax:mMax } = values

    if (sMin==='BBB-' && sMax==='AAA' && mMin==='Baa3' && mMax==='Aaa') {
        values.rating = 'investment-grade'
    } else if (sMin==='C' && sMax==='BB+' && mMin==='C' && mMax==='Ba1') {
        values.rating = 'high-yield'
    } else if (sMin==='ALL' && sMax==='ALL' && mMin==='ALL' && mMax==='ALL') {
        values.rating = 'all-ratings'
    } else {
        values.rating = ''
    }
}


const validateRatings = (values, name, ratings) => {
    let min = ratings.indexOf(values[name + 'Min'])
    let max = ratings.indexOf(values[name + 'Max'])
    let e = {}
    if (max > min) {
        e[name] = 'Please enter higher ratings'
    }
    return e
}

const validateMaturity = (values, name) => {
    let min = parseDate(values[name + 'Min'])
    let max = parseDate(values[name + 'Max'], true)
    if (max < min) {
        return {
            [name]: 'Please select later date',
        }
    }
}

const validateNumbers = (values, name) => {
    let min = parseFloat(values[name + 'Min'])
    let max = parseFloat(values[name + 'Max'])
    let e = {}
    if (max<min) {
        e[name] = 'Please enter max > min'

    }
    return e
}